// extracted by mini-css-extract-plugin
module.exports = {"rtLevelRender":"LevelRender_rtLevelRender__2dNx3","leftSide":"LevelRender_leftSide__1oDWP","mainSide":"LevelRender_mainSide__AelGl","imgBox":"LevelRender_imgBox__2rAqG"};